export const ACCESS_LEVELS = {
  READ_ONLY: 'READ_ONLY',
  READ_WRITE: 'READ_WRITE',
};

export const CSV_DATA = {
  MAX_DEVICES: 360,
  MAX_RECORDS: 53000,
};

export const LOGGER_HISTORY_CODE_AND_HISTORY = {
  1: {
    101: 'CH1 逸脱　上上限　復帰',
    102: 'CH1 逸脱　上上限　発生',
    103: 'CH1 逸脱　上限　復帰',
    104: 'CH1 逸脱　上限　発生',
    105: 'CH1 逸脱　下限　復帰',
    106: 'CH1 逸脱　下限　発生',
    107: 'CH1 逸脱　下下限　復帰',
    108: 'CH1 逸脱　下下限　発生',
    109: 'CH1 警報　上上限　復帰',
    110: 'CH1 警報　上上限　発生',
    111: 'CH1 警報　上限　復帰',
    112: 'CH1 警報　上限　発生',
    113: 'CH1 警報　下限　復帰',
    114: 'CH1 警報　下限　発生',
    115: 'CH1 警報　下下限　復帰',
    116: 'CH1 警報　下下限　発生',
    117: 'CH1 -欠番-',
    118: 'CH1 -欠番-',
    119: 'CH1 -欠番-',
    120: 'CH1 -欠番-',
    121: 'CH1 -欠番-',
    122: 'CH1 -欠番-',
    123: 'CH1 -欠番-',
    124: 'CH1 -欠番-',
    125: 'CH1オーバーレンジ復帰',
    126: 'CH1オーバーレンジ発生',
    127: 'CH1アンダーレンジ復帰',
    128: 'CH1アンダーレンジ発生',
    129: 'CH1バーンアウト復帰',
    130: 'CH1バーンアウト発生',
    131: 'CH1ショート復帰',
    132: 'CH1ショート発生',
    201: 'CH2 逸脱　上上限　復帰',
    202: 'CH2 逸脱　上上限　発生',
    203: 'CH2 逸脱　上限　復帰',
    204: 'CH2 逸脱　上限　発生',
    205: 'CH2 逸脱　下限　復帰',
    206: 'CH2 逸脱　下限　発生',
    207: 'CH2 逸脱　下下限　復帰',
    208: 'CH2 逸脱　下下限　発生',
    209: 'CH2 警報　上上限　復帰',
    210: 'CH2 警報　上上限　発生',
    211: 'CH2 警報　上限　復帰',
    212: 'CH2 警報　上限　発生',
    213: 'CH2 警報　下限　復帰',
    214: 'CH2 警報　下限　発生',
    215: 'CH2 警報　下下限　復帰',
    216: 'CH2 警報　下下限　発生',
    217: 'CH2 -欠番-',
    218: 'CH2 -欠番-',
    219: 'CH2 -欠番-',
    220: 'CH2 -欠番-',
    221: 'CH2 -欠番-',
    222: 'CH2 -欠番-',
    223: 'CH2 -欠番-',
    224: 'CH2 -欠番-',
    225: 'CH2オーバーレンジ復帰',
    226: 'CH2オーバーレンジ発生',
    227: 'CH2アンダーレンジ復帰',
    228: 'CH2アンダーレンジ発生',
    229: 'CH2バーンアウト復帰',
    230: 'CH2バーンアウト発生',
    231: 'CH2ショート復帰',
    232: 'CH2ショート発生',
    301: 'CH3 逸脱　上上限　復帰',
    302: 'CH3 逸脱　上上限　発生',
    303: 'CH3 逸脱　上限　復帰',
    304: 'CH3 逸脱　上限　発生',
    305: 'CH3 逸脱　下限　復帰',
    306: 'CH3 逸脱　下限　発生',
    307: 'CH3 逸脱　下下限　復帰',
    308: 'CH3 逸脱　下下限　発生',
    309: 'CH3 警報　上上限　復帰',
    310: 'CH3 警報　上上限　発生',
    311: 'CH3 警報　上限　復帰',
    312: 'CH3 警報　上限　発生',
    313: 'CH3 警報　下限　復帰',
    314: 'CH3 警報　下限　発生',
    315: 'CH3 警報　下下限　復帰',
    316: 'CH3 警報　下下限　発生',
    317: 'CH3 -欠番-',
    318: 'CH3 -欠番-',
    319: 'CH3 -欠番-',
    320: 'CH3 -欠番-',
    321: 'CH3 -欠番-',
    322: 'CH3 -欠番-',
    323: 'CH3 -欠番-',
    324: 'CH3 -欠番-',
    325: 'CH3オーバーレンジ復帰',
    326: 'CH3オーバーレンジ発生',
    327: 'CH3アンダーレンジ復帰',
    328: 'CH3アンダーレンジ発生',
    329: 'CH3バーンアウト復帰',
    330: 'CH3バーンアウト発生',
    331: 'CH3ショート復帰',
    332: 'CH3ショート発生',
    401: 'CH4 逸脱　上上限　復帰',
    402: 'CH4 逸脱　上上限　発生',
    403: 'CH4 逸脱　上限　復帰',
    404: 'CH4 逸脱　上限　発生',
    405: 'CH4 逸脱　下限　復帰',
    406: 'CH4 逸脱　下限　発生',
    407: 'CH4 逸脱　下下限　復帰',
    408: 'CH4 逸脱　下下限　発生',
    409: 'CH4 警報　上上限　復帰',
    410: 'CH4 警報　上上限　発生',
    411: 'CH4 警報　上限　復帰',
    412: 'CH4 警報　上限　発生',
    413: 'CH4 警報　下限　復帰',
    414: 'CH4 警報　下限　発生',
    415: 'CH4 警報　下下限　復帰',
    416: 'CH4 警報　下下限　発生',
    417: 'CH4 -不明-',
    418: 'CH4 -不明-',
    419: 'CH4 -不明-',
    420: 'CH4 -不明-',
    421: 'CH4 -不明-',
    422: 'CH4 -不明-',
    423: 'CH4 -不明-',
    424: 'CH4 -不明-',
    425: 'CH4オーバーレンジ復帰',
    426: 'CH4オーバーレンジ発生',
    427: 'CH4アンダーレンジ復帰',
    428: 'CH4アンダーレンジ発生',
    429: 'CH4バーンアウト復帰',
    430: 'CH4バーンアウト発生',
    431: 'CH4ショート復帰',
    432: 'CH4ショート発生',
  },
  2: {
    1: '電池残量復帰',
    2: '電池残量低下(残量0本、無線停止)',
    3: 'CH1オーバーレンジ復帰',
    4: 'CH1オーバーレンジ発生',
    5: 'CH2オーバーレンジ復帰',
    6: 'CH2オーバーレンジ発生',
    7: 'CH3オーバーレンジ復帰',
    8: 'CH3オーバーレンジ発生',
    9: 'CH1アンダーレンジ復帰',
    10: 'CH1アンダーレンジ発生',
    11: 'CH2アンダーレンジ復帰',
    12: 'CH2アンダーレンジ発生',
    13: 'CH3アンダーレンジ復帰',
    14: 'CH3アンダーレンジ発生',
    15: 'CH1バーンアウト復帰',
    16: 'CH1バーンアウト発生',
    17: 'CH2バーンアウト復帰',
    18: 'CH2バーンアウト発生',
    19: 'CH3バーンアウト復帰',
    20: 'CH3バーンアウト発生',
    21: 'CH1ショート復帰',
    22: 'CH1ショート発生',
    23: 'CH2ショート復帰',
    24: 'CH2ショート発生',
    25: 'CH3ショート復帰',
    26: 'CH3ショート発生',
    27: 'センサ通信異常復帰',
    28: 'センサ通信異常発生',
    29: '欠番',
    30: '欠番',
    31: '欠番',
    32: '欠番',
    33: 'フラッシュメモリ(プライマリ)異常復帰',
    34: 'フラッシュメモリ(プライマリ)異常発生',
    35: 'フラッシュメモリ(セカンダリ)異常復帰',
    36: 'フラッシュメモリ(セカンダリ)異常発生',
    37: 'ROM_CRC異常復帰',
    38: 'ROM_CRC異常発生',
    39: 'クロック異常復帰',
    40: 'クロック異常発生',
    41: 'キー動作不良復帰',
    42: 'キー動作不良発生',
    43: 'リアルタイムクロック異常復帰',
    44: 'リアルタイムクロック異常発生',
    45: 'リアルタイムクロック(CPU)異常復帰',
    46: 'リアルタイムクロック(CPU)異常発生',
    47: '欠番',
    48: '電池残量低下(残量1本)',
    49: 'センサ機器異常復帰',
    50: 'センサ機器異常発生',
  },
  3: {
    1: '欠番',
    2: '起動',
    3: '電池交換',
    4: '欠番',
    5: '欠番',
    6: '機内モードON',
    7: '機内モードOFF',
    8: '欠番',
    9: '欠番',
    10: 'ファームウェアアップデート',
    11: '不正設定要求',
    12: '欠番',
    13: '欠番',
    14: '欠番',
    15: '欠番',
    16: '欠番',
    17: '欠番',
    18: '欠番',
    19: '欠番',
    20: '設定変更 上上限警報設定値(CH1)',
    21: '設定変更 上限警報設定値(CH1)',
    22: '設定変更 下限警報設定値(CH1)',
    23: '設定変更 下下限警報設定値(CH1)',
    24: '設定変更 上上限警報遅延回数(CH1)',
    25: '設定変更 上限警報遅延回数(CH1)',
    26: '設定変更 下限警報遅延回数(CH1)',
    27: '設定変更 下下限警報遅延回数(CH1)',
    28: '欠番',
    29: '欠番',
    30: '設定変更 スケーリング調整値係数B(CH1)',
    31: '設定変更 スケーリング調整値係数A(CH1)',
    32: '設定変更 上上限警報設定値(CH2)',
    33: '設定変更 上限警報設定値(CH2)',
    34: '設定変更 下限警報設定値(CH2)',
    35: '設定変更 下下限警報設定値(CH2)',
    36: '設定変更 上上限警報遅延回数(CH2)',
    37: '設定変更 上限警報遅延回数(CH2)',
    38: '設定変更 下限警報遅延回数(CH2)',
    39: '設定変更 下下限警報遅延回数(CH2)',
    40: '設定変更 逸脱許容時間選択閾値(CH2）',
    41: '設定変更 逸脱許容時間(CH2）',
    42: '設定変更 スケーリング調整値係数B(CH2)',
    43: '設定変更 スケーリング調整値係数A(CH2)',
    44: '設定変更 上上限警報設定値(CH3)',
    45: '設定変更 上限警報設定値(CH3)',
    46: '設定変更 下限警報設定値(CH3)',
    47: '設定変更 下下限警報設定値(CH3)',
    48: '設定変更 上上限警報遅延回数(CH3)',
    49: '設定変更 上限警報遅延回数(CH3)',
    50: '設定変更 下限警報遅延回数(CH3)',
    51: '設定変更 下下限警報遅延回数(CH3)',
    52: '設定変更 逸脱許容時間選択閾値(CH3）',
    53: '設定変更 逸脱許容時間(CH3）',
    54: '設定変更 スケーリング調整値係数B(CH3)',
    55: '設定変更 スケーリング調整値係数A(CH3)',
    56: '設定変更 上上限警報設定値(CH4)',
    57: '設定変更 上限警報設定値(CH4)',
    58: '設定変更 下限警報設定値(CH4)',
    59: '設定変更 下下限警報設定値(CH4)',
    60: '設定変更 上上限警報遅延回数(CH4)',
    61: '設定変更 上限警報遅延回数(CH4)',
    62: '設定変更 下限警報遅延回数(CH4)',
    63: '設定変更 下下限警報遅延回数(CH4)',
    64: '設定変更 逸脱許容時間選択閾値(CH4）',
    65: '設定変更 逸脱許容時間(CH4）',
    66: '設定変更 スケーリング調整値係数B(CH4)',
    67: '設定変更 スケーリング調整値係数A(CH4)',
    68: '設定変更 電池種',
    69: '設定変更 キーロック',
    70: '設定変更 長距離無線通信CH',
    71: '設定変更 計測周期',
    72: '設定変更 警報監視周期',
    82: '設定変更 ロガー名称',
    83: '設定変更 高速無線通信CH',
    84: '設定変更 高速通信起動のスリープ期間',
    85: '欠番',
    86: '欠番',
    87: '欠番',
    88: '設定変更 イベントボタン制御',
    89: '欠番',
    90: '欠番',
    91: '設定変更 校正日',
    92: '欠番',
    93: '欠番',
    94: '欠番',
    95: '設定変更 プライマリフラッシュメモリ切り替え',
    96: '設定変更 接続許可受信器ID1',
    97: '設定変更 接続許可受信器ID2',
    98: '設定変更 接続許可受信器ID3',
    99: '設定変更 接続許可受信器ID4',
    100: '設定変更 接続許可受信器ID5',
    101: '設定変更 接続許可受信器ID6',
    102: '設定変更 接続許可受信器ID7',
    103: '設定変更 接続許可受信器ID8',
    104: '設定変更 接続許可受信器ID9',
    105: '設定変更 接続許可受信器ID10',
    106: '設定変更 グループ番号',
  },
  4: {
    1: 'イベントON',
    2: 'イベントOFF',
  },
};

export const RECEIVER_HISTORY_CODE_AND_HISTORY = {
  2: {
    1: 'ネットワーク初期化',
    2: '欠番',
    3: '無線LAN APモード変更',
    4: '無線LAN STAモード変更',
    5: '受信器警報メール送信',
    6: '受信器警報メール送信失敗',
    7: 'ロガー警報メール送信',
    8: 'ロガー警報メール送信失敗',
    9: '欠番',
    10: 'ローカルログイン',
    11: 'ローカルログイン失敗',
    12: 'MZsrアプリモードログイン',
    13: 'MZsrアプリモードログイン失敗',
    14: 'MZsrアプリモードログアウト通知失敗',
    15: 'ログアウト',
    16: '無操作ログアウト',
    17: '受信器ソフトウェア更新',
    18: '受信器ソフトウェア更新失敗',
    19: 'バックアップ',
    20: 'バックアップ失敗',
    21: '外部バックアップファイルによる復元',
    22: '外部バックアップファイルによる復元失敗',
    23: '内部自動バックアップによる復元',
    24: '内部自動バックアップによる復元失敗',
    25: 'システムログのファイル出力',
    26: '計測データ収集',
    27: '計測警報履歴収集',
    28: '機器異常警報履歴収集',
    29: '動作履歴収集',
    30: 'イベント履歴収集',
    31: 'システム履歴収集',
    32: '全データ収集',
    33: '内蔵バックアップ電池接続',
    34: '内蔵バックアップ電池切断',
    35: '受信器起動',
    36: '受信器シャットダウン(内蔵バックアップ電池残量少)',
    37: '受信器再起動',
    38: 'ERROR LED消灯',
    39: '受信器自動再起動',
    40: 'ロガーファームアップ操作',
    41: '自動バックアップ実行',
    42: '受信器オンラインソフトウェア更新',
    43: '受信器オンラインソフトウェア更新失敗',
    44: '受信器オンライン自動ソフトウェア更新',
    45: '受信器オンライン自動ソフトウェア更新失敗',
    46: 'クラウドモードログイン',
    47: 'クラウドモードログイン失敗',
    100: '受信器基本設定',
    101: '受信器拡張設定',
    102: '受信器時計設定',
    103: '受信器接点設定',
    104: '欠番',
    105: '受信器接続設定',
    106: 'ブラウザ接続の設定',
    107: 'LTE接続設定',
    108: '無線LAN設定(STAモード)設定',
    109: '有線LAN設定',
    110: '無線LAN直接接続(APモード)設定',
    111: 'ユーザ設定',
    112: 'ロガー登録設定',
    113: '無線通信モード変更',
    114: '一覧表示更新周期変更',
    115: 'MZsrアプリ接続設定',
    116: '時計設定',
    117: 'メール通知設定',
    118: 'ファイル送信(FTP)設定',
    119: 'フィルタリング設定',
    120: '一括設定',
    121: 'ローカル管理者設定変更',
    122: 'ローカル標準ユーザ設定変更',
    123: 'アクセス制限設定変更',
    124: 'チノークラウド接続設定',
    125: '欠番',
    126: 'FTP設定',
    127: 'オンラインソフトウェア更新設定',
    128: '欠番',
    129: '欠番',
    130: '欠番',
    131: '欠番',
    132: '欠番',
    200: 'ロガー設定',
    201: '欠番',
    202: '欠番',
    203: '欠番',
    204: 'ロガー一覧警報クリア',
    205: 'ロガー一覧表示削除',
    206: 'ロガーデータ削除',
    207: '欠番',
  },
  4: {
    1: '欠番',
    2: '欠番',
    3: '欠番',
    4: '欠番',
    5: '欠番',
    6: '欠番',
    7: '受信器故障復帰 (温度測定部1)',
    8: '受信器故障 (温度測定部1)',
    9: '欠番',
    10: '欠番',
    11: '欠番',
    12: '欠番',
    13: '受信器故障復帰 (温度測定部2)',
    14: '受信器故障 (温度測定部2)',
    15: '受信器故障復帰 (温度測定部3)',
    16: '受信器故障 (温度測定部3)',
    17: '受信器故障復帰 (温度測定部4)',
    18: '受信器故障 (温度測定部4)',
    19: '受信器故障 (無線部)',
    20: '受信器故障復帰 (無線部)',
    21: '受信器故障復帰 (メモリ1)',
    22: '受信器故障 (メモリ1)',
    23: '受信器故障復帰 (メモリ2)',
    24: '受信器故障 (メモリ2)',
    25: '受信器故障復帰 (RTC)',
    26: '受信器故障 (RTC)',
    27: '受信器故障復帰 (マイコン)',
    28: '受信器故障 (マイコン)',
    29: '受信器故障復帰 (マイコンメモリ)',
    30: '受信器故障 (マイコンメモリ)',
    31: '受信器故障復帰 (マイコン RTC)',
    32: '受信器故障 (マイコン RTC)',
    33: '受信器故障復帰 (マイコン クロック)',
    34: '受信器故障 (マイコン クロック)',
    35: '欠番',
    36: '欠番',
    37: '欠番',
    38: '欠番',
    39: '受信器シャットダウン(動作温度範囲外)',
    40: '欠番',
    41: '有線LAN通信 復帰',
    42: '有線LAN通信 失敗',
    43: 'LTE通信 復帰',
    44: 'LTE通信 失敗',
    45: 'GPS取得 復帰',
    46: 'GPS取得 失敗',
    47: '受信器故障復帰 (LTE)',
    48: '受信器故障 (LTE)',
    49: '受信器故障復帰 (GPS)',
    50: '受信器故障 (GPS)',
    51: 'SIMカード エラー復帰',
    52: 'SIMカード エラー',
    53: '欠番',
    54: '受信器故障 (EVENT1キー)',
    55: '欠番',
    56: '受信器故障 (EVENT2キー)',
    57: '欠番',
    58: '受信器故障 (RESETキー)',
    59: '欠番',
    60: '受信器故障 (AP/STAキー)',
    61: '受信器故障復帰 (データベース)',
    62: '受信器故障 (データベース)',
    63: '停電復旧',
    64: '停電発生',
    65: '設定ファイル異常復帰',
    66: '設定ファイル異常発生',
    67: '警報メールエラー',
    68: '受信器故障復帰 (ファイルシステム)',
    69: '受信器故障 (ファイルシステム)',
    70: '受信器警報メール送信失敗',
    71: 'ロガー警報メール送信失敗',
    72: '警報メール送信復帰',
    100: 'ロガー受信情報 計測データ異常復帰 (CH1)',
    101: 'ロガー受信情報 計測データ異常 (CH1)',
    102: 'ロガー受信情報 計測データ異常復帰 (CH2)',
    103: 'ロガー受信情報 計測データ異常 (CH2)',
    104: 'ロガー受信情報 計測データ異常復帰 (CH3)',
    105: 'ロガー受信情報 計測データ異常 (CH3)',
    106: 'ロガー受信情報故障復帰 (メモリ)',
    107: 'ロガー受信情報故障 (メモリ)',
    108: 'ロガー受信情報故障復帰 (センサ/メモリ以外)',
    109: 'ロガー受信情報故障 (センサ/メモリ以外)',
  },
  5: {
    1: 'イベント1キー OFF',
    2: 'イベント1キー ON',
    3: 'イベント2キー OFF',
    4: 'イベント2キー ON',
    5: '接点1 OFF',
    6: '接点1 ON',
    7: '接点2 OFF',
    8: '接点2 ON',
  },
};

export const ALARM_SETTINGS = {
  SNOOZE_PAUSE_MINUTES: 1440,
};

export const COMPANY_TIERS = {
  FREE: 'FREE',
  PAID: 'PAID',
  CUSTOM: 'CUSTOM',
};

export const RECEIVER_LIMIT = 0;
export const LOGGER_LIMIT = 5000;

export const R8_CODES = {
  ON_OFF_EVENT: {
    0: 'イベントOFF',
    1: 'イベントON',
  },
  A2_SENSOR_TYPES: {
    0: '内蔵サーミスタ',
    1: '外付けサーミスタ',
    2: '温湿度',
    3: '測温抵抗体',
    4: '電圧',
    5: 'パルス',
    6: 'K熱電対',
    7: 'T熱電対',
  },
};

export const ALARM_FLAG_NUMBERS = {
  CH$CH$上限: 200,
  'CH$CH$上限・上上限': 2200,
  CH$CH$下限: 20,
  'CH$CH$下限・下下限': 22,
};

export const LAST_ACTIVITY_KEY = '__.last_operation_at';